import _ from 'lodash'

export default (namespace, computedName, idProvider) => ({
  computed: {
    [computedName] () {
      let id

      if (this.hasOwnProperty(idProvider)) {
        id = this[idProvider]
      }
      else if (_.isFunction(idProvider)) {
        id = idProvider.apply(this)
      }

      return this.$store.getters[`${namespace}/findById`](id, this.$store.dispatch)
    }
  }
})



// WEBPACK FOOTER //
// ./src/service/findOne.js